module.exports = __webpack_public_path__ + "media/03 Joy to the world.d4f0c15c.mp3";